/* eslint-disable */

import axios from 'axios'

const clearState = (context) => {
  context.commit('clearAdvertiserState');
}

const parseUser = (context, data) => {

  for (var i = 0; i < data.advertisers.length; i++) {

    const advertiser = {
      id: data.advertisers[i].id,
      name: data.advertisers[i].name,
      company_type: data.advertisers[i].company_type,
      description: data.advertisers[i].description,
      website_url: data.advertisers[i].website_url,
      address: data.advertisers[i].address,
      location: data.advertisers[i].store_location,
      has_hid_reward_guide_link: data.advertisers[i].dashboard_has_hid_reward_guide_link,
      is_shopify_merchant: data.advertisers[i].is_shopify_merchant,
      price_rules: data.advertisers[i].price_rules,
      university_ids: data.advertisers[i].university_ids,
    }

    context.commit('addAdvertiser', advertiser);
    if (advertiser.id === context.getters.advertiser_id) {
      context.commit('setAdvertiser', advertiser);
      obtainAdvertiser(context, advertiser.id);
    }
  }

  if (context.getters.advertiser === null) {
    const advertiser = context.getters.advertisers[0];
    context.commit('setAdvertiser', advertiser);
    obtainAdvertiser(context, advertiser.id);
  }
}

const setAdvertiser = (context, newAdvertiser) => {
  context.commit('setAdvertiser', newAdvertiser)
}

const getMerchantCardCounts = async (context, id) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        merchant_id: id,
      }
    }

    await axios.get(context.state.endpoints.merchantCardCounts, payload)
      .then((response)=>{
        context.commit('setAdvertiserCounts', response.data);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const obtainAdvertiser = async (context) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        merchant_id: context.rootState.advertiser.advertiser.id,
      }
    }
    
    await axios.get(context.state.endpoints.merchantDetail, payload)
      .then((response)=>{
        context.dispatch('parseAdvertiser', response.data);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

// const parseAdvertiser = (context, data) => {
//   const payload = {
//     company_description: data.description,
//     website_url: data.website_url,
//     address: data.address,
//   }

//   context.commit('updateAdvertiser', payload);
// }

const updateAdvertiser = (context, payload) => {
  context.commit('updateAdvertiser', payload);
}

const hideRewardGuideLink = (context) => {
  context.commit('hideRewardGuideLink')
}

const uploadAdvertiserUpdates = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`,
      'Content-Type': 'application/json',
    }
  }

  await axios.put(context.state.endpoints.updateMerchant, JSON.stringify(payload), headers)
    .then((response)=>{
      // Do something with response if necessary
    })
    .catch((error)=>{
      console.log(error);
    })
}

const uploadHideRewardGuideLink = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`,
      'Content-Type': 'application/json',
    }
  }

  await axios.patch(context.state.endpoints.merchantHideRewardGuideLink, JSON.stringify(payload), headers)
    .then((response)=>{
      // Do something with response if necessary
    })
    .catch((error)=>{
      console.log(error);
    })
}

export default {
  clearState,
  parseUser,
  // parseAdvertiser,
  setAdvertiser,
  getMerchantCardCounts,
  updateAdvertiser,
  hideRewardGuideLink,
  obtainAdvertiser,
  uploadAdvertiserUpdates,
  uploadHideRewardGuideLink
}